import { useEffect } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';

import { EmployeeService } from 'services';
import { SetPsvScreensFrom, SetPsvScreensFromFailed, SetPsvScreensFromLoading } from 'state/actions';

const publicServiceVehicleTypeId = 3;

function toLocalDateString(date) {
    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    const day = `${date.getDate()}`.padStart(2, '0');

    return `${date.getFullYear()}-${month}-${day}`;
}

// The PSV screens stay hidden unless the switch-on date has been read and has arrived. A missing date or a
// failed lookup hides them, and the lookup is not retried within the page load. `settled` says the answer
// is final: straight away for an asset that is not a PSV, otherwise once the lookup has loaded or failed.
export function usePsvScreensGate(asset) {
    const dispatch = useDispatch();
    const store = useStore();
    const psv = useSelector((state) => state.psv);

    const isPsv = asset?.assetType?.id === publicServiceVehicleTypeId;

    useEffect(loadScreensFrom, [isPsv]);

    // Reads the status from the store rather than the render, so screens mounting together make one call.
    function loadScreensFrom() {
        if (!isPsv || store.getState().psv.status !== "idle") {
            return;
        }

        dispatch(SetPsvScreensFromLoading());

        EmployeeService.getPsvOptions().then((options) => {
            dispatch(SetPsvScreensFrom(options?.screensFrom ?? null));
        }, () => {
            dispatch(SetPsvScreensFromFailed());
        });
    }

    if (!isPsv) {
        return { enabled: false, settled: true };
    }

    const settled = psv.status === "loaded" || psv.status === "failed";

    if (psv.status !== "loaded" || psv.screensFrom == null) {
        return { enabled: false, settled };
    }

    return { enabled: psv.screensFrom.substring(0, 10) <= toLocalDateString(new Date()), settled };
}
